import { useMutation } from "@tanstack/react-query";
import { makeCRMApi } from "../CrmApi";

export const useDirectoryEntrySubscribeMutation = () => {
  const crmApi = makeCRMApi();
  
  const directoryEntrySubscribeMutation = useMutation({
    mutationKey: ['crm-directory-entry-subscribe'],
    mutationFn: ({ directoryId, beUserId }: { directoryId: string, beUserId: string }) => crmApi.subscribeToDirectoryEntry(directoryId, beUserId),
  });
  
  return directoryEntrySubscribeMutation;
}

export const useDirectoryEntryUnsubscribeMutation = () => {
  const crmApi = makeCRMApi();
  
  const directoryEntryUnsubscribeMutation = useMutation({
    mutationKey: ['crm-directory-entry-unsubscribe'],
    mutationFn: ({ directoryId, beUserId }: { directoryId: string, beUserId: string }) => crmApi.unsubscribeFromDirectoryEntry(directoryId, beUserId),
  });
  
  return directoryEntryUnsubscribeMutation;
}
